<template>
  <section class="sub_contents_wrap container">
    <div class="brick_box">
      <div class="view_top">
        <div class="view_title">{{ notice.title }}</div>
        <ul class="view_info">
          <li class="view_user">{{ notice.userName }}</li>
          <li class="view_date">{{ notice.firstRegDatetime }}</li>
        </ul>
        <div class="view_file" v-if="files.length > 0 && files != null">
          <ul>
            <li>
              <span>File</span>
              <a
                v-for="(file, index) in files"
                :key="index"
                href="#"
                @click="downloadFile(file)"
              >
                {{ file.fileNm }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="notice.content" v-html="notice.content" class="view_t"></div>
      <div class="list_bottom_bt">
        <router-link to="/support/notice" class="btn btn-primary btn-lg">{{
          $t("support.notice.list")
        }}</router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { goDownloadFile } from "@/api/file";
import { getNotice } from "@/api/notice";

export default {
  data() {
    return {
      id: "",
      notice: {
        title: "",
        content: "",
        attributeName: "",
        firstRegDatetime: "",
      },
      files: [],
      isTrue: false,
      componentName: null,
      boardId: "",
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.boardId = this.$route.query.boardId;
        // this.boardId = this.$route.params.boardId;
        // if (this.boardId == "" || this.boardId == undefined || this.boardId == null) {
        // let boardId = this.$store.state.boardId;
        // }
        const response = await getNotice(this.boardId);
        this.$store.commit("setBoardId", this.boardId);
        this.notice = response.data.notice;
        this.files = response.data.files;
      } catch (err) {
        console.log(err);
      }
    },
    async downloadFile(file) {
      if (this.$session.get("loginUser") == null) {
        alert(this.$t("alert.pleaseLogIn"));
        return;
      }
      let loader = this.$loading.show({});
      try {
        const res = await goDownloadFile(file.fileId);
        let data = res.data;
        if (!data) {
          return;
        }
        loader.hide();
        const blob = new Blob([data]);
        if (window.navigator.msSaveOrOpenBlob) {
          // compatible IE10
          navigator.msSaveBlob(blob, file.fileId);
        } else {
          // IE core support other non-H5 browsers
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", file.fileNm);
          document.body.appendChild(link);
          link.click();
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style></style>
